export default "__VITE_ASSET__96ab2e6d__"